module.exports = __webpack_public_path__ + "img/wxcode.bda8b26e.png";